<template>
  <div>
    <HeroSection>
      <h1 class="text-white">Compare <span class="text-warning">Mortgage</span> Deals...</h1>
      <p class="text-white">Introduction...</p>
    </HeroSection>
    <div class="bbg-light">
      <div class="container">
        <div class="row">
          <div v-for="item in shoppingBasket" :key="item.uid" class="col-md-3 my-3">
            <div class="card card-hover-shadow card-frame card-bordered" style="cursor: pointer; padding: 8px 0 0;" @click="viewProduct(item)">
              <div class="m-2 position-absolute right-0 top-0">
                <button class="btn btn-xs btn-soft-danger" @click.stop="removeFromShoppingBasket(item)" title="Remove from Basket"><i class="fa fa-trash-alt"></i></button>
              </div>
              <div class="card-body text-center p-0 pb-2 overflow-hidden greyscale">
                <img :src="item.lender.imageUrl" :title="item.lender.lenderName" :alt="item.lender.lenderName" style="max-width: 110px;"/>
                <p class="card-text">{{ item.description }}</p>
              </div>
            </div>
          </div>
        </div>
        <CompareProducts class="mt-8" :products="shoppingBasket"></CompareProducts>
      </div>
    </div>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
import { mapGetters } from "vuex";
import CompareProducts from "@/components/products/CompareProducts";

export default {
  name: "Compare",
  
  components: {
    HeroSection,
    CompareProducts
  },
  
  computed: {
    ...mapGetters([
      "shoppingBasket"
    ])
  }
}
</script>

<style scoped>

</style>